import './styles/main.css';
import JobItem from './components/JobItem';
import { Link } from 'react-router-dom';
import ScrollReveal from './components/ScrollReveal';
import CopyDiscord from './components/CopyDiscord';
import { useEffect } from 'react';

import { projectMeta } from './projectMeta';
import { experiencestMeta } from './jobMeta';

function Main() {
  const workDisplay = experiencestMeta[0];

  const projectDisplay = projectMeta[projectMeta.length - 1];
  useEffect(() => {
    document.title = 'Iskren Dobrev';
  }, []);
  return (
    <>
      <ScrollReveal>
        <div className='segOne center first'>
          <div className='float-left introText' style={{}}>
            <h1 className='reveal-on-scroll'>const jackOfAllTrades = true;</h1>
            <p className='reveal-on-scroll'>From the dreams website, to embedded electronics. The craftsmanship for the immersive VR experiences, automating repetitive tasking, innovative software building, even as far as precisely and creatively engaging your visions. </p>
            <p className='reveal-on-scroll'>A "Jack Of All Trades" realizing your aspirations, as only the power of the mind can expand the limit of your potential</p>
          </div>
          <img src={process.env.PUBLIC_URL + 'me2.jpg'} alt='Welp this is awkward!' className='me center float-right reveal-on-scroll' style={{ width: '45%' }} />
        </div>
        <div className='segTwo center quickInfo'>
          <div className='float-left dashedRightUp'>
            <h2 style={{ textDecoration: "Underline" }} className='reveal-on-scroll'>Recent Experience</h2>
            <JobItem name={workDisplay[0]} date={workDisplay[1]} desc={workDisplay[2]} points={workDisplay[3]} className='mainExp' reveal={true} />
            <div className='workLink'>
              <Link to={"/Experience"} className='roundedBTN content-right reveal-on-scroll'>Older Experience</Link>
            </div>
          </div>
          <div className='float-right'>
            <h2 style={{ textDecoration: "Underline" }} className='reveal-on-scroll'>Recent Projects</h2>
            <JobItem name={projectDisplay.title} date={projectDisplay.date} desc={projectDisplay.description} points={projectDisplay.points} className='mainExp' reveal={true} />
            <div style={{ display: "flex" }}>
              <Link to={"/Projects"} className='roundedBTN reveal-on-scroll' >Older Projects</Link>
            </div>
          </div>
        </div>
        <div className='segOne center'>
          <div className='float-left'>
            <h2 style={{ textAlign: 'center', borderStyle: 'dashed', borderWidth: '0 0 2px 0', padding: "0 0 10px 0" }} className='reveal-on-scroll'>Who am I?</h2>
            <p className='reveal-on-scroll'>I am a 24 year old bulgarian. I love coding, creating experiences, modeling and working with unity. My favorite pastime is watching anime and playing games.</p>
          </div>
        </div>
        <div className='segTwo center'>
          <div className='socialDiv'>
            <h2 style={{ textAlign: 'center', borderStyle: 'dashed', borderWidth: '0 0 2px 0', padding: "0 0 10px 0" }} className='reveal-on-scroll'>Contact info:</h2>
            <div className='socialBox'>
              <a href="mailto:iskrencrome@gmail.com" class="social reveal-on-scroll">
                <img src={process.env.PUBLIC_URL + "contactIcons/Mail.png"} alt="Mail:" />
                <p>iskrencrome@gmail.com</p>
              </a>
              <a href="https://www.linkedin.com/in/iskren-dobrev-16a77b1b8/" target="_blank" rel="noreferrer" class="social reveal-on-scroll">
                <img src={process.env.PUBLIC_URL + "contactIcons/LinkedIn.png"} alt="LinkedIn:" />
                <p>Iskren Dobrev</p>
              </a>
              <a href="https://www.instagram.com/firechargereal/" target="_blank" rel="noreferrer" class="social reveal-on-scroll">
                <img src={process.env.PUBLIC_URL + "contactIcons/Insta.png"} alt="Instagram:" />
                <p>firechargereal</p>
              </a>
              <CopyDiscord />

            </div>
          </div>
        </div>
      </ScrollReveal>
    </>
  );
}

export default Main;
